<!-- Start ecb-web-training-banner-section section -->
<section class="ecb-web-training-banner-section">
  <!-- Start ecb-web-training-banner-overlay div -->
  <div class="ecb-web-training-banner-overlay">
  </div>
  <!-- End ecb-web-training-banner-overlay div -->
  <!-- Start container div -->
  <div class="container ecb-web-training-banner-container hero-inner">
    <!-- Start row div -->
    <div class="row align-items-center">
      <!-- Start col-12 div -->
      <div class="col-12 col-lg-6">
        <!-- Start ecb-web-training-banner-content div -->
        <div class="ecb-web-training-banner-content">
          <!-- Display the workplace health and safety category label. -->
          <span class="pill">Certificate and courses</span>
          <!-- Display the main HSR Training heading. -->

          <!-- Start h1 -->
          <h1>
            Online Training
            <!-- Start slash span -->
            <span class="slash">/</span>
            <!-- End slash span -->
            Course
          </h1>
          <!-- End h1 -->

          <div class="ecb-web-voc-title-line"></div>

          <!-- Start p -->
          <p>Delivering Nationwide training solutions to meet the needs of the new employment market.</p>
          <!-- End p -->
        </div>
        <!-- End ecb-web-training-banner-content div -->
      </div>
      <!-- End col-12 div -->
    </div>
    <!-- End row div -->
  </div>
  <!-- End container div -->
</section>
<!-- End ecb-web-training-banner-section section -->
<!-- Start ecb-shell section -->
<section class="ecb-shell category-page" *ngIf="displayState === 'CATEGORIES'">
  <!-- Start category-heading div -->
  <div class="category-heading">
    <!-- Start h2 -->
    <h2>
      Choose Your
      <!-- Start span -->
      <span>Training Area</span>
      <!-- End span -->
    </h2>
    <!-- End h2 -->
    <!-- Start p -->
    <p>
      Select a category below to view available courses, upcoming sessions and booking options.
      <!-- Start strong -->
      <strong *ngIf="selectedQualificationType">Showing {{ selectedQualificationType }} categories only.</strong>
      <!-- End strong -->
    </p>
    <!-- End p -->
  </div>
  <!-- End category-heading div -->

  <!-- Start category-grid div -->
  <div class="category-grid">
    <!-- Start category-card article -->
    <!--commented by sahan - requested to comment click event and remove the see courses (click)="openCategory(category)" -->
    <article class="category-card" *ngFor="let category of visibleCategoryCards; let i = index"
      [style.animationDelay.ms]="i * 90" (click)="openCategory(category)">
      <!-- Start category-image-wrap div -->
      <div class="category-image-wrap">
        <!-- Start img -->
        <img [src]="getCategoryDisplayImage(category)" [alt]="category.tagName"
          (error)="setDefaultCategoryImage($event)">
        <!-- End img -->
        <!-- Start category-image-overlay div -->
        <div class="category-image-overlay">
        </div>
        <!-- End category-image-overlay div -->
      </div>
      <!-- End category-image-wrap div -->
      <!-- Start category-content div -->
      <div class="category-content">
        <!-- Start category-icon div -->
        <div class="category-icon">
          <!-- Start fa i -->
          <i class="fa" [ngClass]="category.icon">
          </i>
          <!-- End fa i -->
        </div>
        <!-- End category-icon div -->
        <!-- Start h3 -->
        <h3>{{ category.tagName }}</h3>
        <!-- End h3 -->
        <!-- Start p -->
        <div class="ecb-x-course-description ">
          {{ getCourseDescription(category) }}
        </div>
        <!-- End p -->
        <!-- Start category-link button -->
        <button type="button" class="btn ecb-x-course-view-button">

          <span>
            View Course
          </span>

          <i class="bi bi-arrow-right"></i>

        </button>

        <!-- End category-link button -->
      </div>
      <!-- End category-content div -->
    </article>
    <!-- End category-card article -->
  </div>
  <!-- End category-grid div -->
</section>
<!-- End ecb-shell section -->

<!-- Courses list -->
<section class="ecb-shell booking-stepper-wrap long-course-card-page" *ngIf="displayState === 'COURSES_LIST'"
  id="long-course-card-list">
  <div class="course-page-header long-course-list-header">
    <button type="button" class="back-category-btn" (click)="backToCategories()">
      <i class="fa fa-angle-left"></i>
      Back to Categories
    </button>
    <div>
      <span class="section-kicker">Qualifications</span>
      <h2>{{ selectedCategoryName || selectedQualificationType || 'All Courses' }}</h2>
    </div>
  </div>

  <nav class="long-course-breadcrumb" aria-label="Breadcrumb">
    <a routerLink="/">Home</a><i class="fa fa-angle-right"></i>
    <button type="button" (click)="backToCategories()">Qualifications</button><i class="fa fa-angle-right"></i>
    <span>{{ selectedCategoryName || 'Course List' }}</span>
  </nav>

  <div class="long-course-filter-bar">
    <div class="long-course-filter-field course-dropdown-field">
      <label>Course</label>
      <!-- <p-dropdown [options]="courseOptions" [(ngModel)]="selectedFilterCourseId" optionValue="courseId" [filter]="true"
        filterBy="courseCode,courseName,qualificationType" [showClear]="true" [virtualScroll]="true"
        [virtualScrollItemSize]="42" placeholder="All Courses" appendTo="body" (onChange)="onCatalogueFilterChange()">
        <ng-template pTemplate="selectedItem" let-item>
          <span *ngIf="item">{{ item.courseCode }} - {{ item.courseName }}</span>
        </ng-template>
        <ng-template pTemplate="item" let-item>
          <div class="course-option-row"><strong>{{ item.courseCode }}</strong><span>{{ item.courseName }}</span></div>
        </ng-template>
      </p-dropdown> -->
      <p-dropdown [options]="courseOptions" [(ngModel)]="selectedFilterCourseId" optionLabel="courseName"
        optionValue="courseId" [filter]="false" [showClear]="true" [scrollHeight]="'300px'"
        [loading]="courseDropdownLoading" placeholder="All Courses" appendTo="body"
        panelStyleClass="ecb-qualification-dropdown-panel" (onShow)="onCourseOptionsOpened()"
        (onHide)="onCourseOptionsClosed()" (onChange)="onCatalogueFilterChange()">

        <!-- Server-side search -->
        <ng-template pTemplate="header">
          <div class="p-2">
            <input type="search" class="form-control" placeholder="Search qualification code or name"
              [value]="courseDropdownSearchText" (input)="onCourseOptionsSearch($any($event.target).value)">
          </div>
        </ng-template>

        <!-- Selected qualification -->
        <ng-template pTemplate="selectedItem" let-item>
          <span *ngIf="item">
            {{ item.courseCode }} - {{ item.courseName }}
          </span>
        </ng-template>

        <!-- Qualification list -->
        <ng-template pTemplate="item" let-item>
          <div class="course-option-row">
            <strong>{{ item.courseCode }}</strong>
            <span>{{ item.courseName }}</span>
          </div>
        </ng-template>

        <!-- Load next 50 -->
        <ng-template pTemplate="footer">
          <div class="p-2 text-center" *ngIf="
                courseDropdownHasLoaded &&
                courseOptions.length < courseDropdownTotalRecords
            ">

            <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="courseDropdownLoading"
              (click)="onCourseOptionsScroll()">

              {{
              courseDropdownLoading
              ? 'Loading...'
              : 'Load more courses'
              }}

            </button>
          </div>
        </ng-template>

      </p-dropdown>
    </div>
    <div class="long-course-filter-field keyword-field">
      <label for="longCourseKeyword">Keyword</label>
      <div class="long-course-keyword-wrap">
        <i class="fa fa-search"></i>
        <input id="longCourseKeyword" type="search" [(ngModel)]="searchText"
          placeholder="Search code, course name or description" (keyup.enter)="onCatalogueFilterChange()">
      </div>
    </div>
    <button type="button" class="ecb-btn-primary long-course-search-btn" (click)="onCatalogueFilterChange()">
      <i class="fa fa-search"></i> Search
    </button>
    <button type="button" class="ecb-btn-outline long-course-clear-btn" *ngIf="selectedFilterCourseId || searchText"
      (click)="clearCatalogueFilters()">Clear</button>
  </div>

  <div class="ecb-x-course-loading" *ngIf="isCatalogueLoading">
    <div class="spinner-border" role="status"></div><span>Loading courses...</span>
  </div>

  <div class="row g-4" *ngIf="!isCatalogueLoading && courses.length">
    <div class="col-12 col-sm-6 col-lg-4 col-xl-3" *ngFor="let course of courses">
      <article class="ecb-x-course-card" tabindex="0">
        <div class="ecb-x-course-image-wrapper">
          <img *ngIf="hasCourseImage(course)" [src]="course.imageUrl" [alt]="getCourseTitle(course)"
            class="ecb-x-course-image" (error)="setDefaultCourseImage($event)">
          <div class="ecb-x-course-image-fallback" *ngIf="!hasCourseImage(course)">
            <div class="ecb-x-course-fallback-icon"><i class="bi bi-mortarboard"></i></div><span>ECB Training</span>
          </div>
          <span class="ecb-x-course-image-badge" *ngIf="course.qualificationType?.trim()?.toLowerCase() !== 'none'">{{
            course.qualificationType || 'Qualification' }}</span>
        </div>
        <div class="ecb-x-course-card-content">
          <span class="ecb-x-course-code">{{ getCourseCode(course) }}</span>
          <h3>{{ courseDisplayTitle(course) }}</h3>
          <div class="ecb-x-course-description ql-editor" [innerHTML]="getCourseDescription(course) | safeHtml"></div>
          <!--   <div class="ecb-x-course-price">{{ getPrice(course) }}</div> -->
          <a class="btn ecb-x-course-view-button" [routerLink]="['/courses', course.courseId]"
            [queryParams]="courseDetailQueryParams">
            <span>View Course</span><i class="bi bi-arrow-right"></i>
          </a>
        </div>
      </article>
    </div>
  </div>

  <div class="course-empty-filter" *ngIf="!isCatalogueLoading && !courses.length">
    <i class="fa fa-search" aria-hidden="true"></i>
    <h3>No matching courses found</h3>
    <p>Try another course or keyword.</p>
  </div>
  <div class="long-course-pagination" *ngIf="!isCatalogueLoading && catalogueTotalRecords > 0">

    <small>
      {{ catalogueTotalRecords }}
      matching course{{ catalogueTotalRecords === 1 ? '' : 's' }}
    </small>

    <p-paginator [first]="catalogueFirst" [rows]="cataloguePageSize" [totalRecords]="catalogueTotalRecords"
      [rowsPerPageOptions]="[8,12,24]" (onPageChange)="onCataloguePageChange($event)">
    </p-paginator>

  </div>
  <!--  <div class="long-course-pagination" *ngIf="!isCatalogueLoading && catalogueTotalRecords > 0">
    <small>{{ catalogueTotalRecords }} matching course{{ catalogueTotalRecords === 1 ? '' : 's' }}</small>
    <p-paginator [first]="catalogueFirst" [rows]="cataloguePageSize" [totalRecords]="catalogueTotalRecords"
      [rowsPerPageOptions]="[8,12,24]" (onPageChange)="onCataloguePageChange($event)"></p-paginator>
  </div> -->
</section>
<!-- End of Courses list -->

<!-- Start ecb-shell div -->
<div class="ecb-shell booking-stepper-wrap" *ngIf="displayState === 'COURSES'">
  <!-- Start booking-stepper div -->
  <div class="booking-stepper">
    <!-- Start step-item div -->
    <div class="step-item active">
      <!-- Start step-bubble div -->
      <div class="step-bubble">1</div>
      <!-- End step-bubble div -->
      <!-- Start span -->
      <span>Choose Course</span>
      <!-- End span -->
    </div>
    <!-- End step-item div -->
    <!-- Start step-item div -->
    <div class="step-item">
      <!-- Start step-bubble div -->
      <div class="step-bubble">2</div>
      <!-- End step-bubble div -->
      <!-- Start span -->
      <span>Select Date</span>
      <!-- End span -->
    </div>
    <!-- End step-item div -->
    <!-- Start step-item div -->
    <div class="step-item">
      <!-- Start step-bubble div -->
      <div class="step-bubble">3</div>
      <!-- End step-bubble div -->
      <!-- Start span -->
      <span>Your Details</span>
      <!-- End span -->
    </div>
    <!-- End step-item div -->
    <!-- Start step-item div -->
    <div class="step-item">
      <!-- Start step-bubble div -->
      <div class="step-bubble">4</div>
      <!-- End step-bubble div -->
      <!-- Start span -->
      <span>Review & Pay</span>
      <!-- End span -->
    </div>
    <!-- End step-item div -->
    <!-- Start step-item div -->
    <div class="step-item">
      <!-- Start step-bubble div -->
      <div class="step-bubble">5</div>
      <!-- End step-bubble div -->
      <!-- Start span -->
      <span>Confirmation</span>
      <!-- End span -->
    </div>
    <!-- End step-item div -->
  </div>
  <!-- End booking-stepper div -->
</div>
<!-- End ecb-shell div -->
<!-- Start ecb-shell section -->
<section class="ecb-shell booking-page" *ngIf="displayState === 'COURSES'">
  <!-- Start course-page-header div -->
  <div class="course-page-header">
    <!-- Start back-category-btn button -->
    <button type="button" class="back-category-btn" (click)="backToCategories()">
      <!-- Start fa i -->
      <i class="fa fa-angle-left">
      </i>
      <!-- End fa i -->
      Back to Categories
    </button>
    <!-- End back-category-btn button -->
    <!-- Start div -->
    <div>
      <!-- Start section-kicker span -->
      <span class="section-kicker">Selected Category</span>
      <!-- End section-kicker span -->
      <!-- Start h2 -->
      <h2>{{ selectedCategoryName || 'All Courses' }}</h2>
      <!-- End h2 -->
    </div>
    <!-- End div -->
  </div>
  <!-- End course-page-header div -->
  <!-- Start row div -->
  <div class="row g-4 align-items-start">
    <!-- Start col-lg-8 div -->
    <div class="col-lg-8">
      <!-- Start ecb-card div -->
      <div class="ecb-card p-4">
        <!-- Start d-flex div -->
        <div class="d-flex align-items-start justify-content-between gap-3 mb-3 flex-wrap">
          <!-- Start div -->
          <div>
            <!-- Start ecb-card-title h2 -->
            <h2 class="ecb-card-title mb-1">1. Choose your course</h2>
            <!-- End ecb-card-title h2 -->
            <!-- Start ecb-muted p -->
            <p class="ecb-muted mb-0">Choose a qualification and then select its available training date.</p>
            <!-- End ecb-muted p -->
          </div>
          <!-- End div -->
          <!-- Start ecb-btn-outline a -->
          <a routerLink="/cart" class="ecb-btn-outline">
            <!-- Start fa i -->
            <i class="fa fa-shopping-cart">
            </i>
            <!-- End fa i -->
            Cart {{ cartCount }}
          </a>
          <!-- End ecb-btn-outline a -->
        </div>
        <!-- End d-flex div -->
        <!-- Start alert div -->
        <div class="alert alert-info py-2" *ngIf="message">
          <!-- Start fa i -->
          <i class="fa fa-info-circle">
          </i>
          <!-- End fa i -->
          {{ message }}
        </div>
        <!-- End alert div -->
        <!-- Start course-toolbar div -->
        <div class="course-toolbar">
          <!-- Start search-box div -->
          <div class="search-box">
            <!-- Start fa i -->
            <i class="fa fa-search">
            </i>
            <!-- End fa i -->
            <!-- Start input -->
            <input [(ngModel)]="searchText" placeholder="Search Course">
            <!-- End input -->
          </div>
          <!-- End search-box div -->
          <!-- Start ecb-select select -->
          <select class="ecb-select qualification-select" [(ngModel)]="selectedQualificationType"
            (change)="onQualificationTypeChange()" aria-label="Filter by qualification level">
            <!-- Start option -->
            <option value="">All Qualification Types</option>
            <!-- End option -->
            <!-- Start option -->
            <option *ngFor="let qualification of qualificationTypes" [value]="qualification">{{ qualification }}
            </option>
            <!-- End option -->
          </select>
          <!-- End ecb-select select -->
          <!-- Start ecb-select select -->
          <select class="ecb-select" [(ngModel)]="selectedTagSlug" (change)="selectTag(selectedTagSlug)">
            <!-- Start option -->
            <option *ngFor="let tag of tags" [value]="tag.slug">{{ tag.tagName }}</option>
            <!-- End option -->
          </select>
          <!-- End ecb-select select -->
          <!-- Start ecb-select select -->
          <select class="ecb-select" [(ngModel)]="selectedLocation">
            <!-- Start option -->
            <option value="">All Locations</option>
            <!-- End option -->
            <!-- Start option -->
            <option>Melbourne</option>
            <!-- End option -->
            <!-- Start option -->
            <option>Perth</option>
            <!-- End option -->
            <!-- Start option -->
            <option>Online</option>
            <!-- End option -->
          </select>
          <!-- End ecb-select select -->
          <!-- Start filter-btn button -->
          <button type="button" class="filter-btn">
            <!-- Start fa i -->
            <i class="fa fa-sliders">
            </i>
            <!-- End fa i -->
            Filters
          </button>
          <!-- End filter-btn button -->
        </div>
        <!-- End course-toolbar div -->
        <!-- Start course-results div -->
        <div class="course-results">
          <!-- Start course-empty-filter div -->
          <div class="course-empty-filter" *ngIf="!filteredCourses.length">
            <!-- Start fa i -->
            <i class="fa fa-search" aria-hidden="true">
            </i>
            <!-- End fa i -->
            <!-- Start h3 -->
            <h3>No matching courses found</h3>
            <!-- End h3 -->
            <!-- Start p -->
            <p>Try another qualification type, category, location or search term.</p>
            <!-- End p -->
          </div>
          <!-- End course-empty-filter div -->
          <!-- Start booking-course-item article -->
          <article *ngFor="let course of pagedCourses" class="booking-course-item">
            <!-- Start booking-course-card div -->
            <div class="booking-course-card">
              <!-- Start img -->
              <img [src]="getCourseDisplayImage(course)" [alt]="course.courseName"
                (error)="setDefaultCourseImage($event)">
              <!-- End img -->
              <!-- Start course-main div -->
              <div class="course-main">
                <!-- Start course-title-row div -->
                <div class="course-title-row d-flex justify-content-between gap-2">
                  <!-- Start div -->
                  <div>
                    <!-- Start public-course-type span -->
                    <span class="public-course-type cluster" *ngIf="clusterOffers(course).length">
                      <!-- Start fa i -->
                      <i class="fa fa-tags" aria-hidden="true">
                      </i>
                      <!-- End fa i -->
                      Cluster discount available
                    </span>
                    <!-- End public-course-type span -->
                    <!-- Start h3 -->
                    <h3>{{ courseDisplayTitle(course) }}</h3>
                    <!-- End h3 -->
                  </div>
                  <!-- End div -->
                  <!-- Start strong -->
                  <strong>{{ course.currencyCode || 'AUD' }} {{ individualCoursePrice(course) | number:'1.2-2'
                    }}</strong>
                  <!-- End strong -->
                </div>
                <!-- End course-title-row div -->
                <!-- Start p -->
                <p [innerHtml]="course.shortDescription || '-' | safeHtml">
                </p>
                <!-- End p -->
                <!-- Start course-meta-grid div -->
                <div class="course-meta-grid">
                  <!-- Start span -->
                  <span>
                    <!-- Start fa i -->
                    <i class="fa fa-clock-o">
                    </i>
                    <!-- End fa i -->
                    {{ (course.courseTimeCount || 0) + ((course.courseTimeCount || 0) === 1 ? ' Session' : ' Sessions')
                    }}
                  </span>
                  <!-- End span -->
                  <!-- Start span -->
                  <span>
                    <!-- Start fa i -->
                    <i class="fa fa-map-marker">
                    </i>
                    <!-- End fa i -->
                    {{ course.locationName || 'Melbourne' }}
                  </span>
                  <!-- End span -->
                  <!-- Start span -->
                  <span>
                    <!-- Start fa i -->
                    <i class="fa fa-arrows-h">
                    </i>
                    <!-- End fa i -->
                    {{ course.deliveryMode || 'Face to Face' }}
                  </span>
                  <!-- End span -->
                  <!-- Start span -->
                  <span>
                    <!-- Start fa i -->
                    <i class="fa fa-calendar">
                    </i>
                    <!-- End fa i -->
                    {{ course.startDate | date:'d MMM yyyy' }}
                  </span>
                  <!-- End span -->
                </div>
                <!-- End course-meta-grid div -->
              </div>
              <!-- End course-main div -->
            </div>
            <!-- End booking-course-card div -->
            <!-- Start course-list-actions div -->
            <div class="course-list-actions">
              <!-- Start ecb-btn-outline a -->
              <a class="ecb-btn-outline" [routerLink]="['/courses', course.courseId]">
                <!-- Start fa i -->
                <i class="fa fa-eye">
                </i>
                <!-- End fa i -->
                View details
              </a>
              <!-- End ecb-btn-outline a -->
              <!-- Start select-btn button -->
              <button type="button" class="select-btn" [class.added]="isIndividualSelected(course.courseId)"
                [disabled]="!course.isActive" (click)="addPublicCourse(course)">
                {{ isIndividualSelected(course.courseId) ? 'Change selected date' : 'Choose training date' }}
              </button>
              <!-- End select-btn button -->
            </div>
            <!-- End course-list-actions div -->
            <!-- Start ng-container -->
            <!-- Show available cluster discounts returned by the API. -->
            <!-- End ng-container -->
          </article>
          <!-- End booking-course-item article -->
        </div>
        <!-- End course-results div -->
        <!-- Start d-flex div -->
        <div class="d-flex align-items-center justify-content-between mt-3 flex-wrap gap-3">
          <!-- Start ecb-muted small -->
          <small class="ecb-muted">{{ filteredCourses.length }} matching courses / training clusters</small>
          <!-- End ecb-muted small -->
          <!-- Start p-paginator -->
          <p-paginator [first]="first" [rows]="pageSize" [totalRecords]="totalRecords || filteredCourses.length"
            [rowsPerPageOptions]="[5,10,15]" (onPageChange)="onPageChange($event)">
          </p-paginator>
          <!-- End p-paginator -->
        </div>
        <!-- End d-flex div -->
      </div>
      <!-- End ecb-card div -->
    </div>
    <!-- End col-lg-8 div -->
    <!-- Start col-lg-4 div -->
    <div class="col-lg-4">
      <!-- Start booking-summary aside -->
      <aside class="booking-summary ecb-dark-panel p-4">
        <h3>Training cart</h3>
        <p>Courses are organised by type, with dates selected before they are added.</p>
        <div class="summary-row"><span>Selected courses</span><strong>{{ unifiedCart.count }}</strong></div>
        <div class="summary-total"><span>Subtotal</span><strong>{{ unifiedCart.subtotal |
            currency:'AUD':'symbol':'1.2-2' }}</strong></div>
        <a routerLink="/cart" class="ecb-btn-primary w-100 mt-3"><i class="fa fa-shopping-cart"></i> View Cart</a>
      </aside>
      <!-- End booking-summary aside -->
      <!-- Start trust-list div -->
      <div class="trust-list mt-3">
        <!-- Start trust-item div -->
        <div class="trust-item">
          <!-- Start fa i -->
          <i class="fa fa-shield">
          </i>
          <!-- End fa i -->
          <!-- Start div -->
          <div>
            <!-- Start strong -->
            <strong>Nationally Accredited</strong>
            <!-- End strong -->
            <!-- Start span -->
            <span>All courses are nationally recognised.</span>
            <!-- End span -->
          </div>
          <!-- End div -->
        </div>
        <!-- End trust-item div -->
        <!-- Start trust-item div -->
        <div class="trust-item">
          <!-- Start fa i -->
          <i class="fa fa-user-o">
          </i>
          <!-- End fa i -->
          <!-- Start div -->
          <div>
            <!-- Start strong -->
            <strong>Expert Trainers</strong>
            <!-- End strong -->
            <!-- Start span -->
            <span>Learn from experienced professionals.</span>
            <!-- End span -->
          </div>
          <!-- End div -->
        </div>
        <!-- End trust-item div -->
        <!-- Start trust-item div -->
        <div class="trust-item">
          <!-- Start fa i -->
          <i class="fa fa-refresh">
          </i>
          <!-- End fa i -->
          <!-- Start div -->
          <div>
            <!-- Start strong -->
            <strong>Flexible Options</strong>
            <!-- End strong -->
            <!-- Start span -->
            <span>Choose dates and delivery modes.</span>
            <!-- End span -->
          </div>
          <!-- End div -->
        </div>
        <!-- End trust-item div -->
        <!-- Start trust-item div -->
        <div class="trust-item">
          <!-- Start fa i -->
          <i class="fa fa-lock">
          </i>
          <!-- End fa i -->
          <!-- Start div -->
          <div>
            <!-- Start strong -->
            <strong>Secure Booking</strong>
            <!-- End strong -->
            <!-- Start span -->
            <span>Your information is protected.</span>
            <!-- End span -->
          </div>
          <!-- End div -->
        </div>
        <!-- End trust-item div -->
      </div>
      <!-- End trust-list div -->
      <!-- Start need-help div -->
      <div class="need-help ecb-card p-4 mt-3">
        <!-- Start h5 -->
        <h5>Need Help?</h5>
        <!-- End h5 -->
        <!-- Start p -->
        <p>
          <!-- Start fa i -->
          <i class="fa fa-phone">
          </i>
          <!-- End fa i -->
          1300 ECB 256
        </p>
        <!-- End p -->
        <!-- Start p -->
        <p>
          <!-- Start fa i -->
          <i class="fa fa-envelope">
          </i>
          <!-- End fa i -->
          info&#64;ecbtraining.com.au
        </p>
        <!-- End p -->
        <!-- Start ecb-btn-primary button -->
        <button type="button" class="ecb-btn-primary w-100">
          <!-- Start fa i -->
          <i class="fa fa-comments">
          </i>
          <!-- End fa i -->
          Live Chat
        </button>
        <!-- End ecb-btn-primary button -->
      </div>
      <!-- End need-help div -->
    </div>
    <!-- End col-lg-4 div -->
  </div>
  <!-- End row div -->
</section>
<!-- End ecb-shell section -->
<!-- Start p-dialog -->
<p-dialog [(visible)]="displayPopup" [modal]="true" [dismissableMask]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: '1180px', maxWidth: '96vw' }" styleClass="course-detail-dialog long-course-dialog"
  (onHide)="closeCoursePopup()">
  <!-- Start ng-template -->
  <ng-template pTemplate="header">
    <!-- Start long-course-dialog-title div -->
    <div class="long-course-dialog-title">
      <!-- Start span -->
      <span>{{ popupCourse?.courseCode || 'COURSE DETAILS' }}</span>
      <!-- End span -->
      <!-- Start strong -->
      <strong>{{ popupCourse ? courseDisplayTitle(popupCourse) : '' }}</strong>
      <!-- End strong -->
    </div>
    <!-- End long-course-dialog-title div -->
  </ng-template>
  <!-- End ng-template -->
  <!-- Start long-course-popup div -->
  <div class="long-course-popup" *ngIf="popupCourse">
    <!-- Start long-course-hero section -->
    <section class="long-course-hero">
      <!-- Start long-course-hero-copy div -->
      <div class="long-course-hero-copy">
        <!-- Start long-course-code span -->
        <span class="long-course-code">{{ popupCourse.courseCode }}</span>
        <!-- End long-course-code span -->
        <!-- Start h2 -->
        <h2>{{ courseDisplayTitle(popupCourse) }}</h2>
        <!-- End h2 -->
        <!-- Start h3 -->
        <div *ngIf="popupCourse.shortDescription" class="course-short-description-rte"
          [innerHTML]="popupCourse.shortDescription | safeHtml"></div>
        <!-- End h3 -->
        <!-- Start hero-description div -->
        <div class="hero-description course-rte-view public_rte_view"
          [innerHTML]="popupCourse.fullDescription || defaultCourseDescription | safeHtml">
        </div>
        <!-- End hero-description div -->
        <!-- Start hero-actions div -->
        <div class="hero-actions">
          <!-- Start long-btn a -->
          <a class="long-btn long-btn-primary" routerLink="/contact-us"
            [queryParams]="{ courseId: popupCourse.courseId, courseName: popupCourse.courseName }"
            fragment="course-enquiry" (click)="displayPopup = false">
            Enquire Today
            <!-- Start fa i -->
            <i class="fa fa-arrow-right" aria-hidden="true">
            </i>
            <!-- End fa i -->
          </a>
          <!-- End long-btn a -->
          <!-- Start long-btn a -->
          <a *ngIf="popupCourse.brochureUrl" class="long-btn long-btn-outline" [href]="popupCourse.brochureUrl"
            download>
            <!-- Start fa i -->
            <i class="fa fa-download" aria-hidden="true">
            </i>
            <!-- End fa i -->
            Download Brochure
          </a>
          <!-- End long-btn a -->
        </div>
        <!-- End hero-actions div -->
      </div>
      <!-- End long-course-hero-copy div -->
      <!-- Start long-course-hero-image div -->
      <div class="long-course-hero-image">
        <!-- Start img -->
        <img [src]="getCourseDisplayImage(popupCourse)" [alt]="popupCourse.courseName"
          (error)="setDefaultCourseImage($event)">
        <!-- End img -->
        <!-- Start hero-brand-note div -->
        <div class="hero-brand-note">
          <!-- Start strong -->
          <strong>Real Skills</strong>
          <!-- End strong -->
          <!-- Start span -->
          <span>Brighter Communities</span>
          <!-- End span -->
        </div>
        <!-- End hero-brand-note div -->
      </div>
      <!-- End long-course-hero-image div -->
    </section>
    <!-- End long-course-hero section -->
    <!-- Start long-course-summary-grid section -->
    <section class="long-course-summary-grid">
      <!-- Start long-summary-card article -->
      <article class="long-summary-card">
        <!-- Start summary-icon span -->
        <span class="summary-icon">
          <!-- Start fa i -->
          <i class="fa fa-graduation-cap">
          </i>
          <!-- End fa i -->
        </span>
        <!-- End summary-icon span -->
        <!-- Start div -->
        <div>
          <!-- Start h4 -->
          <h4>Delivery Mode</h4>
          <!-- End h4 -->
          <!-- Start ul -->
          <ul *ngIf="deliveryOptionsFor(popupCourse).length; else deliveryFallback">
            <!-- Start li -->
            <li *ngFor="let option of deliveryOptionsFor(popupCourse)">
              <!-- Start fa i -->
              <i class="fa fa-check-circle">
              </i>
              <!-- End fa i -->
              {{ option }}
            </li>
            <!-- End li -->
          </ul>
          <!-- End ul -->
          <!-- Start deliveryFallback ng-template -->
          <ng-template #deliveryFallback>
            <!-- Start p -->
            <p>{{ popupCourse.deliveryMode || 'Delivery mode to be confirmed' }}</p>
            <!-- End p -->
          </ng-template>
          <!-- End deliveryFallback ng-template -->
        </div>
        <!-- End div -->
      </article>
      <!-- End long-summary-card article -->
      <!-- Start long-summary-card article -->
      <article class="long-summary-card">
        <!-- Start summary-icon span -->
        <span class="summary-icon">
          <!-- Start fa i -->
          <i class="fa fa-calendar">
          </i>
          <!-- End fa i -->
        </span>
        <!-- End summary-icon span -->
        <!-- Start div -->
        <div>
          <!-- Start h4 -->
          <h4>Duration</h4>
          <!-- End h4 -->
          <!-- Start ng-container -->
          <ng-container *ngIf="popupCourse.durationOptions?.length; else popupDurationFallback">
            <!-- Start p -->
            <p *ngFor="let item of popupCourse.durationOptions">
              <!-- Start b -->
              <b>{{ item.label }}:</b>
              <!-- End b -->
              {{ item.duration }}
            </p>
            <!-- End p -->
          </ng-container>
          <!-- End ng-container -->
          <!-- Start popupDurationFallback ng-template -->
          <ng-template #popupDurationFallback>
            <!-- Start p -->
            <p>Contact us for course duration</p>
            <!-- End p -->
          </ng-template>
          <!-- End popupDurationFallback ng-template -->
        </div>
        <!-- End div -->
      </article>
      <!-- End long-summary-card article -->
      <!-- Start long-summary-card article -->
      <article class="long-summary-card placement-card">
        <!-- Start summary-icon span -->
        <span class="summary-icon">
          <!-- Start fa i -->
          <i class="fa fa-users">
          </i>
          <!-- End fa i -->
        </span>
        <!-- End summary-icon span -->
        <!-- Start div -->
        <div>
          <!-- Start h4 -->
          <h4>Placement</h4>
          <!-- End h4 -->
          <!-- Start p -->
          <p *ngIf="popupCourse.placementHours != null">
            Minimum
            <!-- Start strong -->
            <strong>{{ popupCourse.placementHours }} hours</strong>
            <!-- End strong -->
          </p>
          <!-- End p -->
          <!-- Start p -->
          <p *ngIf="popupCourse.placementHours == null">Placement requirements vary by course.</p>
          <!-- End p -->
        </div>
        <!-- End div -->
      </article>
      <!-- End long-summary-card article -->
    </section>
    <!-- End long-course-summary-grid section -->
    <!-- Start long-content-grid section -->
    <section class="long-content-grid" [class.single-column]="!prerequisitesFor(popupCourse).length">
      <!-- Start long-info-panel article -->
      <article class="long-info-panel about-panel">
        <!-- Start h3 -->
        <h3>About This Course</h3>
        <!-- End h3 -->
        <!-- Start title-rule div -->
        <div class="title-rule">
        </div>
        <!-- End title-rule div -->
        <!-- Start course-rte-view div -->
        <div class="course-rte-view public_rte_view"
          [innerHTML]="popupCourse.fullDescription || popupCourse.shortDescription || defaultCourseDescription | safeHtml">
        </div>
        <!-- End course-rte-view div -->
        <!-- Start panel-actions div -->
        <div class="panel-actions">
          <!-- Start long-btn a -->
          <a class="long-btn long-btn-primary" routerLink="/contact-us"
            [queryParams]="{ courseId: popupCourse.courseId, courseName: popupCourse.courseName }"
            fragment="course-enquiry" (click)="displayPopup = false">
            Enquire Today
            <!-- Start fa i -->
            <i class="fa fa-arrow-right">
            </i>
            <!-- End fa i -->
          </a>
          <!-- End long-btn a -->
          <!-- Start long-btn a -->
          <a *ngIf="popupCourse.brochureUrl" class="long-btn long-btn-outline" [href]="popupCourse.brochureUrl"
            download>
            <!-- Start fa i -->
            <i class="fa fa-download">
            </i>
            <!-- End fa i -->
            Download Brochure
          </a>
          <!-- End long-btn a -->
          <!-- Start long-btn button -->
          <button type="button" class="long-btn long-btn-fees long-btn-cart"
            (click)="addPopupCourseToCartAndViewCart()">
            <!-- Start fa i -->
            <i class="fa fa-shopping-cart" aria-hidden="true">
            </i>
            <!-- End fa i -->
            Choose Date &amp; Add to Cart - {{ popupCourse.price |
            currency:popupCourse.currencyCode:'symbol':'1.2-2' }}
            <!-- Start fa i -->
            <i class="fa fa-arrow-right" aria-hidden="true">
            </i>
            <!-- End fa i -->
          </button>
          <!-- End long-btn button -->
        </div>
        <!-- End panel-actions div -->
      </article>
      <!-- End long-info-panel article -->
      <!-- Start long-info-panel article -->
      <article class="long-info-panel prereq-panel" *ngIf="prerequisitesFor(popupCourse).length">
        <!-- Start h3 -->
        <h3>
          <!-- Start fa i -->
          <i class="fa fa-file-text-o">
          </i>
          <!-- End fa i -->
          Course Prerequisites
        </h3>
        <!-- End h3 -->
        <!-- Start title-rule div -->
        <div class="title-rule">
        </div>
        <!-- End title-rule div -->
        <!-- Start p -->
        <p>To enrol in this course, you should have:</p>
        <!-- End p -->
        <!-- Start check-list ul -->
        <ul class="check-list">
          <!-- Start li -->
          <li *ngFor="let item of prerequisitesFor(popupCourse)">
            <!-- Start fa i -->
            <i class="fa fa-check-circle">
            </i>
            <!-- End fa i -->
            <!-- Start span -->
            <span>{{ item }}</span>
            <!-- End span -->
          </li>
          <!-- End li -->
        </ul>
        <!-- End check-list ul -->
      </article>
      <!-- End long-info-panel article -->
    </section>
    <!-- End long-content-grid section -->
    <!-- Start outcomes-grid section -->
    <section class="outcomes-grid" [class.single-column]="!pathwaysFor(popupCourse).length">
      <!-- Start long-info-panel article -->
      <article class="long-info-panel career-panel" *ngIf="popupCourse.employmentOutcomes?.length">
        <!-- Start h3 -->
        <h3>
          <!-- Start fa i -->
          <i class="fa fa-briefcase">
          </i>
          <!-- End fa i -->
          Career Opportunities
        </h3>
        <!-- End h3 -->
        <!-- Start title-rule div -->
        <div class="title-rule">
        </div>
        <!-- End title-rule div -->
        <!-- Start p -->
        <p>This qualification can lead to a variety of rewarding roles, including:</p>
        <!-- End p -->
        <!-- Start career-list ul -->
        <ul class="career-list">
          <!-- Start li -->
          <li *ngFor="let outcome of popupCourse.employmentOutcomes">
            <!-- Start fa i -->
            <i class="fa fa-check-circle">
            </i>
            <!-- End fa i -->
            {{ outcome }}
          </li>
          <!-- End li -->
        </ul>
        <!-- End career-list ul -->
      </article>
      <!-- End long-info-panel article -->
      <!-- Start long-info-panel article -->
      <article class="long-info-panel pathways-panel" *ngIf="pathwaysFor(popupCourse).length">
        <!-- Start h3 -->
        <h3>
          <!-- Start fa i -->
          <i class="fa fa-bar-chart">
          </i>
          <!-- End fa i -->
          Pathways to Further Study
        </h3>
        <!-- End h3 -->
        <!-- Start title-rule div -->
        <div class="title-rule">
        </div>
        <!-- End title-rule div -->
        <!-- Start p -->
        <p>{{ popupCourse.pathwaysIntroduction || 'Continue your learning journey and build your career.' }}</p>
        <!-- End p -->
        <!-- Start pathway-row a -->
        <a class="pathway-row" *ngFor="let pathway of pathwaysFor(popupCourse)"
          [routerLink]="['/courses', pathway.relatedCourseId]" (click)="displayPopup = false">
          <!-- Start pathway-row-text span -->
          <span class="pathway-row-text">
            <!-- Start strong -->
            <strong *ngIf="pathway.courseCode">{{ pathway.courseCode }}</strong>
            <!-- End strong -->
            <!-- Start span -->
            <span *ngIf="pathway.courseCode">-</span>
            <!-- End span -->
            <!-- Start span -->
            <span>{{ pathway.courseName }}</span>
            <!-- End span -->
          </span>
          <!-- End pathway-row-text span -->
          <!-- Start fa i -->
          <i class="fa fa-angle-right">
          </i>
          <!-- End fa i -->
        </a>
        <!-- End pathway-row a -->
        <!-- Start pathway-note div -->
        <div class="pathway-note">
          <!-- Start fa i -->
          <i class="fa fa-info-circle">
          </i>
          <!-- End fa i -->
          <!-- Start span -->
          <span>
            {{ popupCourse.pathwaysNote ||
            'Graduates can continue their studies in a range of community services and health related qualifications.'
            }}
          </span>
          <!-- End span -->
        </div>
        <!-- End pathway-note div -->
      </article>
      <!-- End long-info-panel article -->
    </section>
    <!-- End outcomes-grid section -->
    <!-- Start long-info-panel section -->
    <section class="long-info-panel units-panel" *ngIf="activeUnitsFor(popupCourse).length">
      <!-- Start h3 -->
      <h3>
        <!-- Start fa i -->
        <i class="fa fa-book">
        </i>
        <!-- End fa i -->
        Course Units
      </h3>
      <!-- End h3 -->
      <!-- Start title-rule div -->
      <div class="title-rule">
      </div>
      <!-- End title-rule div -->
      <!-- Start p -->
      <p>{{ courseDisplayTitle(popupCourse) }} includes the following units:</p>
      <!-- End p -->
      <!-- Start unit-accordion details -->
      <details class="unit-accordion" *ngIf="coreUnitsFor(popupCourse).length">
        <!-- Start summary -->
        <summary>
          <!-- Start span -->
          <span>
            <!-- Start fa i -->
            <i class="fa fa-book">
            </i>
            <!-- End fa i -->
            Core Units ({{ coreUnitsFor(popupCourse).length }})
          </span>
          <!-- End span -->
          <!-- Start fa i -->
          <i class="fa fa-plus">
          </i>
          <!-- End fa i -->
        </summary>
        <!-- End summary -->
        <!-- Start unit-table div -->
        <div class="unit-table">
          <!-- Start unit-row div -->
          <div class="unit-row" *ngFor="let unit of coreUnitsFor(popupCourse)">
            <!-- Start strong -->
            <strong>{{ unit.code || '—' }}</strong>
            <!-- End strong -->
            <!-- Start span -->
            <span>{{ unit.name }}</span>
            <!-- End span -->
          </div>
          <!-- End unit-row div -->
        </div>
        <!-- End unit-table div -->
      </details>
      <!-- End unit-accordion details -->
      <!-- Start unit-accordion details -->
      <details class="unit-accordion" *ngIf="electiveUnitsFor(popupCourse).length">
        <!-- Start summary -->
        <summary>
          <!-- Start span -->
          <span>
            <!-- Start fa i -->
            <i class="fa fa-book">
            </i>
            <!-- End fa i -->
            Elective Units ({{ electiveUnitsFor(popupCourse).length }})
          </span>
          <!-- End span -->
          <!-- Start fa i -->
          <i class="fa fa-plus">
          </i>
          <!-- End fa i -->
        </summary>
        <!-- End summary -->
        <!-- Start unit-table div -->
        <div class="unit-table">
          <!-- Start unit-row div -->
          <div class="unit-row" *ngFor="let unit of electiveUnitsFor(popupCourse)">
            <!-- Start strong -->
            <strong>{{ unit.code || '—' }}</strong>
            <!-- End strong -->
            <!-- Start span -->
            <span>{{ unit.name }}</span>
            <!-- End span -->
          </div>
          <!-- End unit-row div -->
        </div>
        <!-- End unit-table div -->
      </details>
      <!-- End unit-accordion details -->
    </section>
    <!-- End long-info-panel section -->
    <!-- Start booking-options-panel section -->
    <!-- End booking-options-panel section -->
  </div>
  <!-- End long-course-popup div -->
</p-dialog>
<!-- End p-dialog -->

<app-occurrence-picker *ngIf="selectingOccurrenceCourse" kind="QUALIFICATION"
  [courseId]="selectingOccurrenceCourse.courseId" (closed)="selectingOccurrenceCourse=null"></app-occurrence-picker>